import { create } from "zustand";
import { Mode } from "@cloudscape-design/global-styles";

interface CustomBrandingAssetStore {
    wallpaperPath: string;
    brandLogoPath: string;
    hasTermsOfService: boolean;
    isResourceReady: boolean;
    customFontBasedCloudscapeTheme: Mode | undefined;
    setWallPaperPath: (path: string) => void;
    setBrandLogoPath: (path: string) => void;
    setHasTermsOfService: (value: boolean) => void;
    setIsResourceReady: (value: boolean) => void;
    setCustomFontBasedCloudscapeTheme: (theme: Mode | undefined) => void;
}

export const useCustomBrandingAssetStore = create<CustomBrandingAssetStore>(
    (set) => ({
        wallpaperPath: "",
        brandLogoPath: "",
        termsOfService: undefined,
        hasTermsOfService: false,
        isResourceReady: false,
        customFontBasedCloudscapeTheme: undefined,
        setWallPaperPath: (path) => {
            set(() => ({
                wallpaperPath: path,
            }));
        },
        setBrandLogoPath: (path) => {
            set(() => ({
                brandLogoPath: path,
            }));
        },
        setHasTermsOfService: (value) => {
            set(() => ({
                hasTermsOfService: value,
            }));
        },
        setIsResourceReady: (value) => {
            set(() => ({
                isResourceReady: value,
            }));
        },
        setCustomFontBasedCloudscapeTheme: (theme) => {
            set(() => ({
                customFontBasedCloudscapeTheme: theme,
            }));
        },
    })
);
